export default __webpack_public_path__ + "static/media/0008.f0448501.png";